class Layout {
  source

  constructor (source) {
    this.source = source
  }

  render (contenteditable = false, fields, id, colorPrint = false) {
    const tempEl = window.document.createElement('div')
    tempEl.innerHTML = contenteditable ? this.source : this.#removeContenteditable()

    tempEl.querySelectorAll('[data-field]').forEach((field) => {
      const fieldName = field.dataset.field

      if (fields && fieldName in fields) {
        if (fieldName === 'page-number') {
          const length = field.innerText.length
          field.innerHTML = String(fields[fieldName]).padStart(length, 0)
        } else {
          field.innerHTML = fields[fieldName]
        }
      }

      if (fieldName === 'isbn' && fields && fields.isbn && typeof fields.isbn === 'string' && fields.isbn.trim() && !fields.isbn.includes('*')) {
        field.removeAttribute('contenteditable')
        field.setAttribute('contenteditable', 'false')
      }
    })

    tempEl.querySelector('.page').id = id
    tempEl.querySelector('.page').dataset.colorPrint = colorPrint

    return tempEl.innerHTML
  }

  #removeContenteditable () {
    return this.source.replaceAll(' contenteditable', '')
      .replaceAll(/\sdata-image="\S+"/gm, '')
      .replaceAll(/\sdata-editor=".+"/gm, '')
  }
}

export { Layout }
